import type { PageThemeDefinition } from "../types";

export const darkTheme: PageThemeDefinition = {
  id: "dark",
  labelKey: "robot.setting.page_theme.dark",
  preview: {
    background: "#14172B",
    cardBg: "#1e2338",
    text: "#ffffff",
  },
  tokens: {
    background: "#14172B",
    cardBg: "#1e2338",
    text: "#ffffff",
    textSecondary: "#9aa3b2",
    border: "#2a2f47",
    headerBg: "#14172B",
    inputBg: "#14172B",
    messageBg: "#1e2338",
    senderBg: "#14172B",
    statusOnline: "#6bcf6b",
    statusEnding: "#ff7875",
    starActive: "#ffc53d",
    starInactive: "#4a4f63",
    shadow: "rgba(0, 0, 0, 0.5)",
    hoverBg: "#1e2338",
    accent: "#4a9eff",
    appearance: "dark",
    chatMessageText: "#FFFFFF",
    chatAgentBubbleBg: "#252B42",
    chatAgentBubbleBorder: "#3A4568",
    chatUserGradientStart: "#4a9eff",
    chatUserGradientEnd: "#1677ff",
    chatUserMessageText: "#FFFFFF",
    chatInputFieldBg: "#0a0d18",
    chatInputText: "#FFFFFF",
    chatInputPlaceholder: "#9aa3b2",
    chatMediaBg: "#0a0d18",
    chatIconColor: "#FFFFFF",
    chatLinkColor: "#4a9eff",
  },
};
